webpackJsonp([25705806517176],{

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rebass = __webpack_require__(9);
	
	var _Heading = __webpack_require__(14);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _Theory = __webpack_require__(26);
	
	var _Theory2 = _interopRequireDefault(_Theory);
	
	var _Exercise = __webpack_require__(25);
	
	var _Exercise2 = _interopRequireDefault(_Exercise);
	
	var _Command = __webpack_require__(24);
	
	var _Command2 = _interopRequireDefault(_Command);
	
	var _P = __webpack_require__(15);
	
	var _P2 = _interopRequireDefault(_P);
	
	var _SH = __webpack_require__(16);
	
	var _SH2 = _interopRequireDefault(_SH);
	
	var _Toc = __webpack_require__(20);
	
	var _Toc2 = _interopRequireDefault(_Toc);
	
	var _ButtonLink = __webpack_require__(13);
	
	var _ButtonLink2 = _interopRequireDefault(_ButtonLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-useless-escape */
	/* eslint-disable import/no-webpack-loader-syntax */
	
	var Page = function Page() {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Toc2.default, { active: "api" }),
	    _react2.default.createElement(
	      _Heading2.default,
	      { fontSize: 5 },
	      "Apis"
	    ),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      "We have seen how to write websites that render HTML. How different is this from writing APIs?"
	    ),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      "Place this controller in",
	      " ",
	      _react2.default.createElement(
	        _rebass.Code,
	        null,
	        "src/Controller/ApiMovieController.php"
	      )
	    ),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      "And compare it side by side with our ",
	      _react2.default.createElement(
	        _rebass.Code,
	        null,
	        "MovieController"
	      )
	    ),
	    ".",
	    _react2.default.createElement(_SH2.default, { code: __webpack_require__(622) }),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      "There are not many changes. Basically:"
	    ),
	    _react2.default.createElement(
	      "ul",
	      null,
	      _react2.default.createElement(
	        "li",
	        null,
	        "We restrict routes to its HTTP method (something that we could do in the web version)."
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "We return meaningful HTTP Status codes."
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "Instead of using templating, we serialize the values."
	      )
	    ),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      "Other parts of our code (Event Listeners, Services... remain untouched)."
	    ),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      "This is another advantage of having lean Controllers."
	    ),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      "A big part of writing great APIs is dealing with serialization."
	    ),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      "In this case, for instance, we are saying that we are serializing properties that are in the group \"movie\". We can define these groups in our Entities."
	    ),
	    _react2.default.createElement(
	      _Theory2.default,
	      null,
	      _react2.default.createElement(
	        _P2.default,
	        null,
	        "Serializer for the win."
	      )
	    ),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      "Install it with",
	      _react2.default.createElement(_SH2.default, {
	        language: "bash",
	        code: "\ncomposer req serializer\n        "
	      })
	    ),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      "Let's see the definition of groups in ",
	      _react2.default.createElement(
	        _rebass.Code,
	        null,
	        "src/Entity/Movie.php"
	      )
	    ),
	    _react2.default.createElement(_SH2.default, { code: __webpack_require__(636) }),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      "And now in ",
	      _react2.default.createElement(
	        _rebass.Code,
	        null,
	        "src/Entity/Actor.php"
	      )
	    ),
	    _react2.default.createElement(_SH2.default, { code: __webpack_require__(633) }),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      "Let's try our API:"
	    ),
	    _react2.default.createElement(_SH2.default, {
	      language: "bash",
	      code: "\ncurl -X GET http://localhost:8000/api/movies\n        "
	    }),
	    _react2.default.createElement(_SH2.default, {
	      language: "bash",
	      code: "\ncurl -X GET http://localhost:8000/api/movies/1\n        "
	    }),
	    _react2.default.createElement(_SH2.default, {
	      language: "bash",
	      code: "\ncurl -X POST http://localhost:8000/api/movies/1/sale -d '{\n    \"numTickets\": 4,\n    \"fullName\": \"Barack Obama\"\n}'\n        "
	    }),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      "We could continue seeing examples of how to use the serializer. But let's see instead a powerful tool for building APIs."
	    ),
	    _react2.default.createElement(
	      _Heading2.default,
	      { fontSize: 5 },
	      "Api Platform"
	    ),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      "Appi Platform allows us to create very complete APIs with lots of useful tools requiring minimal configuration."
	    ),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      "To install it:"
	    ),
	    _react2.default.createElement(
	      _Command2.default,
	      null,
	      "composer req api"
	    ),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      "As we have more routes, let's configure the routes of Api Platform so they are prefixed by \"/apiplat\":"
	    ),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      "Edit ",
	      _react2.default.createElement(
	        _rebass.Code,
	        null,
	        "config/routes/api_platform.yaml"
	      ),
	      ":"
	    ),
	    _react2.default.createElement(_SH2.default, {
	      language: "yaml",
	      code: "\napi_platform:\n    resource: .\n    type: api_platform\n    prefix:   '/apiplat'\n"
	    }),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      "We need to tell Api Platform which Entities are going to be used as resources of our API. Edit ",
	      _react2.default.createElement(
	        _rebass.Code,
	        null,
	        "src/Entity/Movie.php"
	      ),
	      ":"
	    ),
	    _react2.default.createElement(_SH2.default, {
	      code: "\nuse ApiPlatform\\Core\\Annotation\\ApiResource;\n\n/**\n * @ORM\\Entity(repositoryClass=\"App\\Repository\\MovieRepository\")\n * @ORM\\Table(name=\"movie\")\n * @ApiResource(attributes={\"normalization_context\"={\"groups\"={\"movie\"}}})\n */\nclass Movie\n        "
	    }),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      "And the same in ",
	      _react2.default.createElement(
	        _rebass.Code,
	        null,
	        "src/Entity/Actor.php"
	      ),
	      ":"
	    ),
	    _react2.default.createElement(_SH2.default, {
	      code: "\nuse ApiPlatform\\Core\\Annotation\\ApiResource;\n\n/**\n * @ORM\\Entity(repositoryClass=\"App\\Repository\\MovieRepository\")\n * @ORM\\Table(name=\"actor\")\n * @ApiResource(attributes={\"normalization_context\"={\"groups\"={\"actor\"}}})\n */\nclass Actor\n        "
	    }),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      "And that is it! Visit",
	      " ",
	      _react2.default.createElement(
	        _rebass.Link,
	        { href: "http://localhost:8000/apiplat" },
	        "http://localhost:8000/apiplat"
	      ),
	      "."
	    ),
	    _react2.default.createElement(
	      _Exercise2.default,
	      null,
	      _react2.default.createElement(
	        _P2.default,
	        null,
	        "Play around a bit with API Platform, testing the different endpoints that have been automatically created for you."
	      )
	    ),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      "Api Platform has created a fully functional Level 3 Restful API from the mapping of our entities, with documentation."
	    ),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      "Note however that real projects are much more than a CRUD, so you will still have to implement your own custom Controllers, Events, Services and so on, using the concepts from previous sections."
	    ),
	    _react2.default.createElement(_ButtonLink2.default, { to: "/admin", title: "Go to next section" })
	  );
	};
	
	exports.default = Page;
	module.exports = exports["default"];

/***/ }),

/***/ 622:
/***/ (function(module, exports) {

	module.exports = "<?php\nnamespace App\\Controller;\n\nuse Symfony\\Component\\HttpFoundation\\Response;\nuse Symfony\\Component\\HttpFoundation\\Request;\nuse Symfony\\Bundle\\FrameworkBundle\\Controller\\Controller;\nuse Symfony\\Component\\Routing\\Annotation\\Route;\nuse Sensio\\Bundle\\FrameworkExtraBundle\\Configuration\\Method;\nuse App\\Form\\SaleType;\nuse App\\Form\\EnquiryType;\nuse App\\Entity\\Movie;\nuse App\\Entity\\Sale;\nuse App\\Entity\\Enquiry;\nuse App\\Entity\\Ticket;\nuse App\\Event\\SaleEvent;\nuse App\\Logger\\SaleLogger;\nuse Symfony\\Component\\Serializer\\SerializerInterface;\nuse Symfony\\Component\\HttpFoundation\\JsonResponse;\n\nclass ApiMovieController extends Controller\n{\n    /**\n     * @Route(\"/api/movies\", name=\"get_movies\")\n     * @Method({\"GET\"})\n     */\n    public function index(SerializerInterface $serializer)\n    {\n        $movies = $this->getDoctrine()\n            ->getRepository(Movie::class)\n            ->findAll();\n\n        return new JsonResponse($serializer->serialize($movies, 'json', ['groups' => ['movie']]), 200, [], true);\n    }\n\n    /**\n     * @Route(\"/api/movies/{movieId}\", name=\"get_movie\")\n     * @Method({\"GET\"})\n     */\n    public function movie(SerializerInterface $serializer, int $movieId)\n    {\n        $em = $this->getDoctrine()->getManager();\n        $movie = $em->getRepository(Movie::class)->findOneWithActors($movieId);\n\n        return new JsonResponse($serializer->serialize($movie, 'json', ['groups' => ['movie']]), 200, [], true);\n\n    }\n\n    /**\n     * @Route(\"/api/movies/{movieId}/sale\", name=\"post_booking\")\n     * @Method({\"POST\"})\n     */\n    public function newSale(SaleLogger $saleLogger, Request $request, $movieId)\n    {\n        $sale = new Sale();\n        $movie = $this->getDoctrine()\n            ->getRepository(Movie::class)\n            ->find($movieId);\n\n        $form = $this->createForm(SaleType::class, $sale, ['movie' => $movie, 'csrf_protection' => false]);\n\n        $data = json_decode($request->getContent(), true);\n        $form->submit($data);\n\n        if ($form->isSubmitted() && $form->isValid()) {\n            $em = $this->getDoctrine()->getManager();\n            $em->persist($sale);\n\n            $numTickets = $data['numTickets'];\n\n            $this->get('event_dispatcher')\n                ->dispatch(\n                    SaleEvent::NAME,\n                    new SaleEvent($sale, $movie, $numTickets)\n                );\n\n            $em->flush();\n\n            $saleLogger->log($sale);\n\n            // Location should be a GET request to the sale\n            return new Response(null, 201, [\n                'Location' => $this->generateUrl(\n                    'get_movie',\n                    ['movieId' => $movie->getId()]\n                ),\n            ]);\n        }\n\n        // Here we should serialize the errors of the form\n        return new Response(null, 406);\n    }\n}"

/***/ }),

/***/ 633:
/***/ (function(module, exports) {

	module.exports = "use Symfony\\Component\\Serializer\\Annotation as Serializer;\n\n    //...\n    \n    /**\n     * @ORM\\Column(type=\"integer\")\n     * @ORM\\Id\n     * @ORM\\GeneratedValue(strategy=\"AUTO\")\n     * @Serializer\\Groups({\"movie\", \"actor\"})\n     */\n    private $id;\n\n    /**\n     * @ORM\\Column(type=\"string\")\n     * @Serializer\\Groups({\"actor\"})\n     */\n    private $name;\n\n    /**\n     * @ORM\\Column(type=\"string\")\n     * @Serializer\\Groups({\"actor\"})\n     */\n    private $picture;\n\n    /**\n     * @ORM\\ManyToMany(targetEntity=\"Movie\", mappedBy=\"actors\")\n     * @Serializer\\Groups({\"actor\"})\n     */\n    private $movies;"

/***/ }),

/***/ 636:
/***/ (function(module, exports) {

	module.exports = "use Symfony\\Component\\Serializer\\Annotation as Serializer;\n\n        //...\n        \n        /**\n         * @ORM\\Column(type=\"integer\")\n         * @ORM\\Id\n         * @ORM\\GeneratedValue(strategy=\"AUTO\")\n         * @Serializer\\Groups({\"movie\", \"actor\"})\n         */\n        private $id;\n    \n        /**\n         * @ORM\\Column(type=\"string\")\n         * @Serializer\\Groups({\"movie\"})\n         */\n        private $name;\n    \n        /**\n         * @ORM\\Column(type=\"string\", length=100)\n         * @Serializer\\Groups({\"movie\"})\n         */\n        private $director;\n    \n        /**\n         * @ORM\\Column(type=\"smallint\")\n         * @Serializer\\Groups({\"movie\"})\n         */\n        private $year;\n    \n        /**\n         * @ORM\\Column(type=\"string\")\n         * @Serializer\\Groups({\"movie\"})\n         */\n        private $picture;\n    \n        /**\n         * @ORM\\ManyToMany(targetEntity=\"Actor\", inversedBy=\"movies\")\n         * @Serializer\\Groups({\"movie\"})\n         */\n        private $actors;\n    \n        /**\n         * @ORM\\OneToMany(targetEntity=\"Ticket\", mappedBy=\"movie\")\n         */\n        private $tickets;"

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-api-js-a51cd76f02d51047697b.js